/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  Typography,
  ListItemIcon,
  Divider,
  Button,
  Hidden,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faEnvelope, faHeadset, faHome, faPhone, faPhoneAlt, faQuestionCircle, faSignOutAlt, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import icon_placeholder from "@assets/images/icon_placeholder.png";
import { Image, DarkModeToggler } from "@components/atoms";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@store/user";
import { isMobile } from 'react-device-detect';

import { connect_modules } from "@assets/data/connect_modules_list.js";
import applications_list from "@assets/data/external_applications_list.json";
import GMR_Connect_Portal from "@assets/images/GMR_Connect_Portal.pdf";
import { SafetyUserContext } from 'src/App';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 9999,
  },
  listItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  navLink: {
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  listItemIcon: {
    minWidth: 'auto',
  },
  closeIcon: {
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  menu: {
    display: 'flex',
  },
  menuItem: {
    marginRight: theme.spacing(8),
    '&:last-child': {
      marginRight: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
  },
  divider: {
    width: '100%',
  },
  noUnderline: {
    textDecoration: 'none',
  },
  row: {
    display: "flex",
    alignItems: "center",
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  listItemText: {
    paddingLeft: theme.spacing(1),
  },
  iconColor: {
    color: theme.palette.primary.main,
  },
  logoImage: {
    width: 18,
    height: 18,
  },
  logoRectangle: {
    width: '15%',
  },
  logoContainer: {
    width: '75%',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    // height: 40,
    // marginBottom: 20,
    // fontSize: "10px",
    textAlign: "center",
    borderRadius: theme.spacing(2),
    color: theme.palette.text.primary,
    "&:hover": {
      background: theme.palette.background.dashButton,
    },
  },
  darkMode: {
    cursor: "pointer",
    "&:hover > .menu-item, &:hover svg": {
      color: theme.palette.primary.dark,
    },
    "&.menu-item--no-dropdown": {
      paddingRight: 0,
    },
  },
  bottomPush: {
    position: "fixed",
    bottom: 0,
    textAlign: "center",
    paddingBottom: 10,
  },
  rotate: {
    transform: "rotate(180deg)",
  },
  headerText: {
    fontWeight: 550,
  },
  cursor: {
    cursor: "pointer",
  },
  subMenuButtons: {
    justifyContent: "flex-start",
    paddingLeft: theme.spacing(4),
  }
}));

const SidebarNav = props => {
  const { onClose, className, themeToggler, themeMode, ...rest } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { currentCounty } = useSelector((state) => state.counties);
  const { user } = useSelector((state) => state.user);

  const [isSupportMenuOpen, setIsSupportMenuOpen] = useState(false);
  const { isSafetyUser } = useContext(SafetyUserContext);

  const signOut = () => {
    dispatch(logout());
    history.push("/");
  };

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      <ListItem className={classes.closeIcon} onClick={() => onClose()}>
        <ListItemIcon className={classes.listItemIcon}>
          <CloseIcon fontSize="small" />
        </ListItemIcon>
      </ListItem>
      <Hidden smUp>
      <ListItem className={clsx(classes.row, classes.spaceBetween)}>
        <Typography variant="subtitle1" color="textPrimary" className={classes.headerText}>
          Hello, {user.firstName} {user.lastName}
        </Typography>
      </ListItem>
      </Hidden>
      <ListItem className={clsx(classes.row, classes.spaceBetween)}>
        <Typography variant="h6" color="textPrimary" >
          Menu
        </Typography>
        <DarkModeToggler themeMode={themeMode} onClick={() => themeToggler()} />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={clsx(classes.listItem)}>
        <Link to="/dashboard" className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
          <FontAwesomeIcon 
            icon={faHome}
            size="1x"
            className={classes.iconColor}
          />
          <Typography
            color="textPrimary"
            className={clsx(classes.listItemText, "menu-item")}
            onClick={() => onClose()}
          >
            Home
          </Typography>
        </Link>
      </ListItem>          
      <ListItem className={clsx(classes.listItem)}>
        <Link to="/account" className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
          <FontAwesomeIcon 
            icon={faUserCircle}
            size="1x"
            className={classes.iconColor}
          />
          <Typography
            color="textPrimary"
            className={clsx(classes.listItemText, "menu-item")}
            onClick={() => onClose()}
          >
            Profile
          </Typography>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant="h6" color="textPrimary" >
          GMR Connect
        </Typography>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      {connect_modules.map((application, index) => (
        (application.isActive || isSafetyUser) && (
          <ListItem className={clsx(classes.listItem)}>
            <Link to={`${application.link}?state=${currentCounty.state}&county=${currentCounty.county}`} className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
            {application.logo && (
              <Image
                className={classes.logoImage}
                src={application.logo ? application.logo : icon_placeholder}
                lazy={false}
              />
            )}
              <Typography
                color="textPrimary"
                className={clsx(classes.listItemText, "menu-item")}
                onClick={() => onClose()}
              >
                {application.name}
              </Typography>
            </Link>
          </ListItem>
        )
      ))}
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant="h6" color="textPrimary" >
          GMR Applications
        </Typography>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      {applications_list.map((application, index) => (
        <ListItem className={clsx(classes.listItem)}>
          <a href={application.externalLink} target="_blank" rel="noreferrer" className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
            {application.logo && (
              <Image
                className={classes.logoRectangle}
                src={application.logo ? application.logo : icon_placeholder}
                lazy={false}
              />
            )}
            <Typography
              color="textPrimary"
              className={clsx(classes.listItemText, "menu-item")}
              onClick={() => onClose()}
            >
              {application.name}
            </Typography>
          </a>
        </ListItem>
      ))}
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant="h6" color="textPrimary" >
          Help
        </Typography>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={clsx(classes.listItem)}>
        <a target="_blank" rel="noreferrer" href={GMR_Connect_Portal} className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
          <FontAwesomeIcon 
            icon={faQuestionCircle}
            size="1x"
            className={classes.iconColor}
            />
          <Typography
            color="textPrimary"
            className={clsx(classes.listItemText, "menu-item")}
            onClick={() => onClose()}
            >
            User Guide
          </Typography>
        </a>
      </ListItem>  
      <ListItem className={clsx(classes.listItem, classes.cursor)} onClick={() => setIsSupportMenuOpen(!isSupportMenuOpen)}>
        <div className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
          <FontAwesomeIcon 
            icon={faHeadset}
            size="1x"
            className={classes.iconColor}
          />
          <Typography
            color="textPrimary"
            className={clsx(classes.listItemText, "menu-item")}
          >
            Support
          </Typography>
          <div className={classes.listItemText}>
            <FontAwesomeIcon 
              icon={isSupportMenuOpen ? faChevronUp : faChevronDown}
              size="1x"
              className={classes.iconColor}
            />
          </div>
        </div>
      </ListItem>
      {isSupportMenuOpen && (
        isMobile ? 
          <ListItem className={clsx(classes.listItem)}>
            <a 
              href={isMobile ? 'tel:8662679111' : null} 
              className={clsx(classes.noUnderline, classes.row, classes.logoContainer, classes.subMenuButtons)}
            >
              <FontAwesomeIcon 
                icon={faPhoneAlt}
                size="1x"
                className={clsx(classes.iconColor)}
              />
              <Typography
                variant="caption"
                color="textPrimary"
                className={clsx(classes.listItemText, "menu-item")}
              >
                IT Help Desk <br /> (866) 267-9111
              </Typography>
            </a>
          </ListItem> :
          <ListItem className={clsx(classes.listItem)}>
            <div className={clsx(classes.noUnderline, classes.row, classes.logoContainer, classes.subMenuButtons)}>
              <FontAwesomeIcon 
                icon={faPhoneAlt}
                size="1x"
                className={clsx(classes.iconColor)}
              />
              <Typography
                variant="caption"
                color="textPrimary"
                className={clsx(classes.listItemText, "menu-item")}
              >
                IT Help Desk <br /> (866) 267-9111
              </Typography>
            </div>
        </ListItem>  
      )}
      {isSupportMenuOpen && (
        <ListItem className={clsx(classes.listItem)}>
          <a 
            href="mailto:MobileSupport@gmr.net?subject=GMR Connect Portal Support"
            className={clsx(classes.noUnderline, classes.row, classes.logoContainer, classes.subMenuButtons)}
          >
            <FontAwesomeIcon 
              icon={faEnvelope}
              size="1x"
              className={clsx(classes.iconColor)}
            />
            <Typography
              variant="caption"
              color="textPrimary"
              className={clsx(classes.listItemText, "menu-item")}
            >
              MobileSupport@gmr.net
            </Typography>
          </a>
        </ListItem>
      )}
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={clsx(classes.listItem)}>
        <Link to="/" onClick={signOut} className={clsx(classes.noUnderline, classes.row, classes.logoContainer)}>
          <FontAwesomeIcon 
            icon={faSignOutAlt}
            size="1x"
            className={clsx(classes.iconColor, classes.rotate)}
          />
          <Typography
            color="textPrimary"
            className={clsx(classes.listItemText, "menu-item")}
            onClick={() => onClose()}
          >
            Sign Out
          </Typography>
        </Link>
      </ListItem>  
      {/* <ListItem className={classes.listItem}>
        <Button
          variant="outlined"
          fullWidth
          component="a"
          href="/documentation"
        >
          Documentation
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          component="a"
          target="blank"
          href="/"
        >
          Another Cool Button
        </Button>
      </ListItem> */}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default SidebarNav;
